export const NOT_AVAILABLE = {code:-1, label:"NOT AVAILABLE"};
export const UNKNOWN = {code: 0, label:"UNKNOWN"};
export const ABSENT = {code: 1, label:"ABSENT"};
export const NETWORK_LOCKED = {code: 2, label:"NETWORK LOCKED"};
export const PIN_REQUIRE = {code: 3, label:"PIN REQUIRE"};
export const PUK_REQUIRE = {code: 4, label:"PUK REQUIRE"};
export const READY = {code: 5, label:"READY"};



// WEBPACK FOOTER //
// ./js/core/gateway/service/modules/kpi/converter/enums/SimStateEnum.js